<template>
    <div class="template_card" :class="item.item_type">
        <div class="type">
            {{ type[item.item_type] }}
        </div>
        <!-- <div class="title">
            {{ item.title }}
        </div> -->
        <div class="time">
            <cl-svg-icon icon-class="clock"></cl-svg-icon>
            {{ item.start }}-{{ item.end }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },
    data() {
        return {
            type: {
                match: this.$t('schedule.比赛'),
                training: this.$t('schedule.训练'),
                meeting: this.$t('schedule.会议'),
                physical: this.$t('schedule.体测'),
            },
        }
    },
}
</script>
<style lang="scss" scoped>
.template_card {
    padding: 16px 12px;
    margin: 10px;
    border-radius: 2px;
    .type {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
    }
    // .title {
    //     overflow: hidden;
    //     max-width: 140px;
    //     height: 20px;
    //     margin-top: 8px;
    //     font-family: 'PingFang SC';
    //     font-style: normal;
    //     font-weight: 500;
    //     font-size: 14px;
    //     line-height: 20px;
    //     white-space: nowrap;
    //     text-overflow: ellipsis;
    // }
    .time {
        margin-top: 6px;
        font-family: 'Akrobat';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
    }
}
.training {
    border-left: 3px solid #60bf52;
    background: rgba(96, 191, 82, 0.08);
    .type,
    .time {
        color: #60bf52;
    }
}
.match {
    border-left: 3px solid #a486e8;
    background: rgba(164, 134, 232, 0.08);
    .type,
    .time {
        color: #a486e8;
    }
}

.physical {
    border-left: 3px solid #00cd8c;
    background: rgba(0, 205, 141, 0.08);
    .type,
    .time {
        color: #00cd8c;
    }
}

.meeting {
    border-left: 3px solid #587de3;
    background: rgba(88, 125, 227, 0.08);
    .type,
    .time {
        color: #587de3;
    }
}
</style>
